export function isValidTimeString(time: string) {
  // hh:mm:ss

  if (typeof time !== 'string') {
    return false;
  }

  if (!time) {
    return true;
  }

  if (!/^(?:[0-9]{2}):(?:[0-9]{2}):(?:[0-9]{2})$/.test(time)) {
    return false;
  }

  const timeParts = time.split(':');
  const hours = Number(timeParts[0]);
  const minutes = Number(timeParts[1]);
  const seconds = Number(timeParts[2]);

  return hours < 24 && minutes < 60 && seconds < 60;
}
